import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";

function ApproveCompanyTransaction({ status, transHeadId, authDetailId, onHide }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const formik = useFormik({
        initialValues: {
            reason: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.reason) {
                errors.reason = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["status"] = status;
            data["authDetailId"] = authDetailId;
            data["transHeadId"] = transHeadId;
            await handlePostRequest(data, "zbizgateway/nonFin/company/authorizeTransaction");
            onHide();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>{status === "A" ? "Approve" : "Reject"} Authorize Company Transaction</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-field">
                                <label htmlFor="reason" className={classNames({ "p-error": isFormFieldValid("reason") }, "Label__Text")}>
                                    Reason<span className="Label__Required">*</span>
                                </label>
                                <InputTextarea placeholder="Add Reason......." id="reason" name="reason" value={formik.values.reason} rows={5} cols={10} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("reason") }, "TextArea__Round")} />
                                {getFormErrorMessage("reason")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} type="submit" label="Ok" className="Btn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default ApproveCompanyTransaction;
